<yc-form-label
  name="TagColor"
  [srOnly]="noLabel"
  [label]="'tags:lblTagColor' | ycI18n: 'Tag color'">
</yc-form-label>

<div class="d-flex" role="listbox" id="TagColor">
  <a *ngFor="let colorOption of colors"
    role="option"
    [attr.aria-selected]="color === colorOption.value"
    [attr.aria-label]="colorOption.display"
    [class]="tagColorClassMap[colorOption.value]"
    [class.selected]="color === colorOption.value"
    [ycTrackClick]="'Select tag color'"
    (click)="colorChange.emit(colorOption.value)">
  </a>
</div>
